import React from 'react'
import { Box, Typography } from '@mui/material'

import { INTERAX_COLORS } from '../../../../constants/colors'
import { useFeatureFlags } from '../../../../shared/hooks/useFeatureFlags'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'

interface FlagRowProps {
  label: string
  enabled: boolean
  enabledText: string
  disabledText: string
}

const FlagRow: React.FC<FlagRowProps> = ({ label, enabled, enabledText, disabledText }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px',
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)'
    }}
  >
    <Typography sx={{ fontSize: '16px', fontWeight: 500, color: INTERAX_COLORS.white }}>{label}</Typography>
    <Box
      sx={{
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: 600,
        backgroundColor: enabled ? INTERAX_COLORS.green : INTERAX_COLORS.thunderGrey,
        color: INTERAX_COLORS.white
      }}
    >
      {enabled ? enabledText : disabledText}
    </Box>
  </Box>
)

/**
 * Dev-mode-only readout of the feature flags that affect this user's session.
 */
export const FeatureFlagsStatus: React.FC = () => {
  const { t } = useTranslation()
  const { isGamerEnabled, isFacilitatorEnabled, isLanguageSwitcherEnabled } = useFeatureFlags()

  return (
    <Box
      sx={{
        padding: '24px',
        backgroundColor: INTERAX_COLORS.heritageBlue40,
        borderRadius: '12px',
        border: `1px solid ${INTERAX_COLORS.heritageBlue}`
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontSize: '20px',
          fontWeight: 600,
          color: INTERAX_COLORS.white,
          marginBottom: '16px'
        }}
      >
        {t('facilitator.trainingSprint.profile.featureFlags')}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <FlagRow
          label="Gamer"
          enabled={isGamerEnabled}
          enabledText={t('home.gamerEnabled')}
          disabledText={t('home.gamerDisabled')}
        />
        <FlagRow
          label="Facilitator"
          enabled={isFacilitatorEnabled}
          enabledText={t('home.facilitatorEnabled')}
          disabledText={t('home.facilitatorDisabled')}
        />
        <FlagRow
          label="Language Switcher"
          enabled={isLanguageSwitcherEnabled}
          enabledText={t('home.languageSwitcherEnabled')}
          disabledText={t('home.languageSwitcherDisabled')}
        />
      </Box>
    </Box>
  )
}
